export default "__VITE_ASSET__81e98358__"